// config.js — URL base da API.
// Em produção, o backend serve o frontend na mesma origem, então o padrão é '/api'.
// Em desenvolvimento (frontend em outra porta), defina REACT_APP_API_URL no build,
// ex.: REACT_APP_API_URL=http://localhost:3000/api npm start
const API_URL = process.env.REACT_APP_API_URL || '/api';

export default API_URL;
